// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"bdb4afa67f823608441d","655":"db251fb3d1b001b53975"}[chunkId] + ".js";
};